import { HamburgerCloseIcon, HeaderContainer, isLoggedIn } from "@shapr3d/frontend-lib";

import { ShareModalContextProvider } from "../../../contexts/ShareModalFormContext";
import useAccount from "../../../hooks/useAccount";
import { ProjectUserRole, useProject } from "../../../hooks/useProject";
import { LoginButton } from "../components/LoginButton/LoginButton";
import { LogoHeader } from "../components/LogoHeader/LogoHeader";
import { MenuHeader } from "../components/MenuHeader/MenuHeader";
import { ShareProjectModal } from "../components/ShareModal/ShareProjectModal";
import { StartModelingButton } from "../components/StartModelingButton/StartModelingButton";

import style from "./TeamsHeader.module.css";

interface HeaderTeamsProps {
  teamId?: string;
  sidebarOpen?: boolean;
  setSidebarOpen?: (value: boolean) => void;
}

export const TeamsHeader: React.FC<HeaderTeamsProps> = ({
  teamId,
  sidebarOpen,
  setSidebarOpen,
}) => {
  const { data: accountData, isPending: isAccountPending } = useAccount();
  const { data: projectData } = useProject();

  return (
    <HeaderContainer>
      {sidebarOpen !== undefined && (
        <HamburgerCloseIcon
          className={style.hamburger}
          open={sidebarOpen}
          onClick={() => setSidebarOpen?.(!sidebarOpen)}
        />
      )}
      <LogoHeader teamId={teamId} />
      <div className={style.buttonContainer}>
        <StartModelingButton />

        {projectData?.userRole === ProjectUserRole.Owner && (
          <ShareModalContextProvider>
            <ShareProjectModal />
          </ShareModalContextProvider>
        )}

        {isLoggedIn() && !isAccountPending && <MenuHeader accountData={accountData} />}
        {!isLoggedIn() && (
          <>
            <div className={style.separator} />
            <LoginButton />
          </>
        )}
      </div>
    </HeaderContainer>
  );
};
